import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './_stories.scss'
import Stories from 'react-insta-stories';
import CloseIcon from '@mui/icons-material/Close';
import zIndex from '@mui/material/styles/zIndex';
function StoriesComponent() {
  const [stories, setStories] = useState();
  const [storyOpen, setStoryOpen] = useState(false)
  const [indexStory, setIndexStory] = useState()
  const userName = useSelector((user) => user.user.info.customer_full_heading)
  const navigate = useNavigate()
  useEffect(() => {
    init()
  }, [])

  const init = async () => {
    const storiesApp = `https://my.revoluce.it/area_utente/gestione/api/stories/getStories.php?tkn_pvt=xxx&customer_id=xxx`
    const { data } = await axios.get(storiesApp)
    setStories(data.data)
  }
  const handleStory = (i) => {
    setStoryOpen(true)
    setIndexStory(i)
  }
  return (
    <>
      {storyOpen ? (
        <Storia storiesData={stories} close={setStoryOpen} indexStory={indexStory} />
      ) : (
        <div className="storiesWrapper">
          <div className="profileWrapper" onClick={() => navigate('/enrica/profilo')}>
            <div className="profile">
              <img src={userName && userName ? `https://avatars.dicebear.com/api/initials/${userName}.svg` : `https://avatars.dicebear.com/api/initials/revoluce.svg`} alt="foto profilo" />
              <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="50" r="40" />
              </svg>
            </div>
            <p>PROFILO</p>
          </div>
          <div className='stories'>
            {stories && stories.map((storia) => (
              <div className="storiaWrapper" key={storia.id_story} onClick={(i) => handleStory(parseFloat(storia.id_story) - 1)}>
                <div className="storia">
                  <img src={storia.link_immagine} alt="" />
                  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" stroke={storia.esadecimale}>
                    <circle cx="50" cy="50" r="40" />
                  </svg>
                </div>
                <p>{storia.titolo}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  )
}
export default StoriesComponent


function Storia({storiesData, close, indexStory}) {
  const navigate = useNavigate()
  const boxStyle = {
    zIndex: '1000',
    marginBottom: '20%'
  }
  const titleStyle = {
    fontSize: '24px',
    color: '#fff',
    fontWeight: 'bold',
    marginBottom: '0.5rem'
  }
  const descriptionStyle = {
    fontSize: '14px',
    color: '#fff',
    fontWeight: '700',
    lineHeight: '17px',
    marginBottom: '0.8rem'
  }
 const overlayStyle = {
  position: 'absolute',
  left: 0,
  top: 0,
 }
 const buttonStyle = {
  borderRadius: '50px',
  width: '120px',
  textAlign: 'center',
  fontSize: '12px',
  outline: 'none',
  border: 'none',
  background: '#fff',
  zIndex: '1000',
  padding: '8px'

 }
 const customSeeMore = {
	textAlign: 'center',
	fontSize: 14,
	bottom: 20,
	position: 'relative'
}
const closeWrapper = {
	position: 'absolute',
  top: '3%',
  left: '0',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: '0 20px',
  zIndex: '1000',
}

  const stories = storiesData.map((story) => ({
		content: () => {
			return <div style={{padding: '20px', display: 'flex', alignItems: 'end', height: '100%', width: '100%', backgroundImage: `url(${story.link_immagine})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover'}}>
				<div style={{background: `linear-gradient(to bottom, ${story.rgba} 0%, ${story.rgba} 20%, ${story.rgba} 30%, ${story.rgba} 70%, ${story.esadecimale} 100%)`, position: 'absolute', top: 0, left: 0, height: '100%', width: '100%'}} />
        <div style={closeWrapper} onClick={() => close(false)}>
          <CloseIcon  style={{fill: '#fff', fontSize: '30px'}}/>
        </div>
        <div style={boxStyle}>
          <h1 style={titleStyle}>{story.titolo}</h1>
          <p style={descriptionStyle}>{story.descrizione}</p>
          <div onClick={() => story.link_app.includes('http') ? window.open(story.link_app) : navigate(story.link_app)} style={buttonStyle}>
            <p style={{color: story.esadecimale, fontWeight: 'bold'}}>SCOPRI</p>
          </div>
        </div>
			</div>
		},
	}))
  // const stories = [{ url: 'https://picsum.photos/1080/1920', header: { heading: 'Mohit Karekar', subheading: 'Posted 5h ago', profileImage: 'https://picsum.photos/1000/1000' } }, { url: 'https://fsa.zobj.net/crop.php?r=dyJ08vhfPsUL3UkJ2aFaLo1LK5lhjA_5o6qEmWe7CW6P4bdk5Se2tYqxc8M3tcgYCwKp0IAyf0cmw9yCmOviFYb5JteeZgYClrug_bvSGgQxKGEUjH9H3s7PS9fQa3rpK3DN3nx-qA-mf6XN', header: { heading: 'Mohit Karekar', subheading: 'Posted 32m ago', profileImage: 'https://picsum.photos/1080/1920' } }, { url: 'https://media.idownloadblog.com/wp-content/uploads/2016/04/iPhone-wallpaper-abstract-portrait-stars-macinmac.jpg', header: { heading: 'mohitk05/react-insta-stories', subheading: 'Posted 32m ago', profileImage: 'https://avatars0.githubusercontent.com/u/24852829?s=400&v=4' } }, { url: 'https://storage.googleapis.com/coverr-main/mp4/Footboys.mp4', type: 'video', duration: 1000 }, { url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4', type: 'video' }, { url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4', type: 'video' }, 'https://images.unsplash.com/photo-1534856966153-c86d43d53fe0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=564&q=80']

  return (
    <div className="layerStories">
      <Stories
        stories={stories}
        defaultInterval={4000}
        height='100%'
        width='100%'
        currentIndex={indexStory}
      />
    </div>
  )
}